import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="yuppy-app">
      <header className="header">
        <div className="container header-container">
          <div className="logo">
            <Link to="/">
              <img src={require('./assets/images/fixed-logo-1024.png')} alt="Yuppy Logo" className="logo-img" />
              yuppy
            </Link>
          </div>
          <nav className="navigation">
            <ul>
              <li><Link to="/">Home</Link></li>
            </ul>
          </nav>
        </div>
      </header>
      <div style={{ maxWidth: 700, margin: '100px auto 60px auto', padding: '32px', background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.07)' }}>
        <h1>Yuppy Terms of Use</h1>
        <p><strong>Effective Date:</strong> June 30, 2025</p>
        <p><strong>Last Updated:</strong> 7/27/2025</p>
        
        <p>These Terms of Use ("Terms") govern your use of Yuppy ("we," "our," or "us") via our mobile app, website, and other related services (collectively, the "Services"). By using Yuppy, you agree to comply with these Terms.</p>
        
        <h2>1. Eligibility</h2>
        <p>You must be at least 13 years old to use Yuppy. If you are under 18, you must have permission from a parent or legal guardian.</p>
        
        <h2>2. Account Responsibilities</h2>
        <p>You are responsible for all activity on your account.</p>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate information</li>
          <li>Maintain the confidentiality of your login credentials</li>
          <li>Notify us if you suspect unauthorized activity</li>
        </ul>
        <p>We reserve the right to suspend or terminate accounts that violate these Terms.</p>
        
        <h2>3. User Content</h2>
        <p>By posting content (e.g., photos), you grant Yuppy a non-exclusive, worldwide, royalty-free license to use, reproduce, display, and distribute your content within the app, on our website, and in Yuppy-related marketing.</p>
        <p>You retain ownership of your content, but agree not to upload material that:</p>
        <ul>
          <li>Violates laws or third-party rights</li>
          <li>Contains explicit, offensive, or harmful material</li>
          <li>Includes private or confidential information without consent</li>
        </ul>
        <p>We reserve the right to remove content that violates these Terms.</p>
        
        <h2>4. Prohibited Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Harass, impersonate, or abuse other users</li>
          <li>Post spam or disrupt the platform's functionality</li>
          <li>Reverse-engineer or tamper with our code or infrastructure</li>
          <li>Use Yuppy for illegal, abusive, or harmful activities</li>
        </ul>
        
        <h2>5. Termination</h2>
        <p>We may suspend or permanently delete your account for violating these Terms.</p>
        <p>You may request deletion of your account at any time by contacting yuppy.nyc.team@gmail.com.</p>
        
        <h2>6. Disclaimer</h2>
        <p>Yuppy is provided "as is" and "as available" without warranties of any kind.</p>
        <p>We do not guarantee uninterrupted access, error-free operation, or the accuracy of content submitted by users.</p>
        
        <h2>7. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Yuppy is not liable for:</p>
        <ul>
          <li>Indirect, incidental, or consequential damages</li>
          <li>Data loss, service interruption, or technical issues</li>
          <li>Harm caused by user-submitted content</li>
        </ul>
        <p>Your sole remedy for dissatisfaction with Yuppy is to stop using the Services.</p>
        
        <h2>8. Changes to These Terms</h2>
        <p>We may update these Terms periodically. Updated versions will be posted within the app or on our website. Continued use of the app after changes constitutes your acceptance.</p>
        
        <h2>9. Governing Law</h2>
        <p>These Terms are governed by the laws of the State of New York, without regard to its conflict of law provisions.</p>
        
        <h2>10. Contact Us</h2>
        <p>For any legal, technical, or account-related inquiries, please contact:</p>
        <p>📧 yuppy.nyc.team@gmail.com</p>
      </div>
    </div>
  );
} 